module.exports = __webpack_public_path__ + "img/BMWGroup_BMW_MINI_Grey-Colour_RGB.d5f0aad0.png";